import { FilterConfig } from '../../shared/models/filter-config.model';
import { FilterType } from '../../shared/models/filter-type.enum';
import { AppMetaData, AppMetaDataLookups } from '../../../meta-data/app-meta-data.service';

export class AcsTrendsFilterConfig {
    static getFilterConfigs(): FilterConfig[] {
        return [
            {
                field: 'examinerId',
                accessKey: 'examiner',
                label: 'Examiner/Check Instructor',
                type: FilterType.Dropdown,
                lookupId: AppMetaDataLookups.FlightSchoolExaminerBySchool,
                attribute: AppMetaData.RoAssessmentAcsMissedCodeFact.Attributes.FlightSchoolExaminerId,
                placeholder: 'Select Examiner',
                iconClass: 'fa fa-user-tie'
            },
            {
                field: 'flightSchoolId',
                accessKey: 'flightSchool',
                label: 'Flight School',
                type: FilterType.Dropdown,
                lookupId: AppMetaDataLookups.FlightSchoolNoneOtherRemoved,
                attribute: AppMetaData.RoAssessmentAcsMissedCodeFact.Attributes.FlightSchoolId,
                placeholder: 'Select Flight School',
                iconClass: 'fa fa-school'
            },
            {
                field: 'flightSchoolInstructorId',
                accessKey: 'flightInstructor',
                label: 'Flight Instructor',
                type: FilterType.Dropdown,
                lookupId: AppMetaDataLookups.FlightSchoolInstructorBySchool,
                attribute: AppMetaData.RoAssessmentAcsMissedCodeFact.Attributes.FlightSchoolInstructorId,
                placeholder: 'Select Flight Instructor',
                iconClass: 'fa fa-user'
            },
            {
                field: 'checkrideTypeId',
                accessKey: 'checkrideType',
                label: 'Check Ride Type',
                type: FilterType.Dropdown,
                 lookupId: AppMetaDataLookups.CheckRideTypeWithGrade,
                attribute: AppMetaData.RoAssessmentAcsMissedCodeFact.Attributes.CheckrideTypeId,
                placeholder: 'Select Type',
                iconClass: 'fas fa-clipboard-check'
            },
            {
                field: 'attemptClassificationId',
                accessKey: 'attemptClassification',
                label: 'Attempt Classification',
                type: FilterType.Dropdown,
                lookupId: AppMetaDataLookups.CheckRideTestAttemptClassificationAllItems,
                attribute: AppMetaData.RoAssessmentAcsMissedCodeFact.Attributes.CheckRideTestAttemptClassificationId,
                placeholder: 'Select Attempt Classification',
                iconClass: 'fas fa-layer-group'
            },
            {
                field: 'dateRange',
                accessKey: 'dateRange',
                label: 'Date Range',
                type: FilterType.DateRange,
                attribute: AppMetaData.RoAssessmentAcsMissedCodeFact.Attributes.CheckrideDateTime,
                iconClass: 'fas fa-calendar-alt'
            },
            {
                field: 'testType',
                accessKey: 'testType',
                label: 'Test Type',
                type: FilterType.Dropdown,
                 lookupId: AppMetaDataLookups.ApplicantAcsWrittenResultTypeAllItems,
                attribute: AppMetaData.RoAssessmentAcsMissedCodeFact.Attributes.ApplicantAcsWrittenResultTypeId,
                placeholder: 'Select Test Type',
                iconClass: 'fas fa-file-alt'
            }
        ];
    }
}
